export default "__VITE_PUBLIC_ASSET__d50d2248__"